module.exports = __webpack_public_path__ + "img/Proofsheet - Pink - Selected.2a73fca0.png";